module.exports = __webpack_public_path__ + "static/media/contact2.d792504b.png";